import { Link } from "capitalrx-components-2.0/lib/general";
import styled from "styled-components";

export const ThemedLink = styled(Link)`
  color: ${(props) => props.theme?.primary_button_color} !important;
`;

export const ThemedAnchor = styled.a`
  color: ${(props) => props.theme?.primary_button_color} !important;
`;
